import parse from "date-fns/parse";
import format from "date-fns/format";

export const formatDate = (dateStr, toFormatStr = "dd.MM.yyyy", fromFormatStr = "yyyy-MM-dd") => {
    if (!dateStr) return "";
    const date = parse(dateStr, fromFormatStr, new Date());
    return format(date, toFormatStr);
};

export const formatDatetime = (dateStr, toFormatStr = "dd.MM.yyyy HH:mm", fromFormatStr = "yyyy-MM-dd HH:mm:ss") => {
    if (!dateStr) return "";
    const date = parse(dateStr, fromFormatStr, new Date());
    return format(date, toFormatStr);
};

export const formatDatetimeDontSeconds = (dateStr, toFormatStr = "dd.MM.yyyy", fromFormatStr = "yyyy-MM-dd HH:mm:ss") => {
  if (!dateStr) return "";
  const date = parse(dateStr, fromFormatStr, new Date());
  return format(date, toFormatStr);
};

export const currencyFormat = value => {
    return (+value).toLocaleString("ru-RU", {
        style: "currency",
        currency: "RUB",
    });
};

export const dateToFormat = (dateStr, format = "dd.MM.yyyy") => {
    const dateComponents = getDateComponents(dateStr);
    if (!dateComponents) return null;
    return format
        .replace("yyyy", dateComponents.year)
        .replace("MM", dateComponents.month)
        .replace("dd", dateComponents.day);
};

const getDateComponents = dateStr => {
    if (!dateStr) return null;
    const dateComponents = {};
    // const dmyMatches = dateStr.match(/^\d{2}([./-])\d{2}\1\d{4}$/)
    // const ymdMatches = dateStr.match(/^\d{4}([./-])\d{2}\1\d{2}$/)
    const dmyMatches = dateStr.match(/\d{2}([./-])\d{2}\1\d{4}/);
    const ymdMatches = dateStr.match(/\d{4}([./-])\d{2}\1\d{2}/);
    if (!!dmyMatches) {
        dateComponents.day = dmyMatches[0].split(dmyMatches[1])[0];
        dateComponents.month = dmyMatches[0].split(dmyMatches[1])[1];
        dateComponents.year = dmyMatches[0].split(dmyMatches[1])[2];
    } else if (!!ymdMatches) {
        dateComponents.day = ymdMatches[0].split(ymdMatches[1])[2];
        dateComponents.month = ymdMatches[0].split(ymdMatches[1])[1];
        dateComponents.year = ymdMatches[0].split(ymdMatches[1])[0];
    } else return null;
    return dateComponents;
};
